import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AuthService } from 'src/app/pages/core/abstraction/auth.service';
import { ICON_CARD_ACCOUNT } from 'src/app/pages/core/models/Crypto';
import { PAYMENT_SERVICE_NAME } from 'src/app/pages/core/models/User';
import { TYPE_ACCOUNT } from 'src/app/pages/core/models/Withdrawal';
import errors from 'src/app/pages/core/utils/errorCodes';

enum COMPANY_TYPE {
  BANK = 'bank',
  PSP = 'psp',
}

@Component({
  selector: 'app-account-card',
  templateUrl: './account-card.component.html',
  styleUrls: ['./account-card.component.scss'],
})
export class AccountCardComponent implements OnInit, AfterViewInit {
  @ViewChild('optionModalButton') optionModalButtonElement: ElementRef;
  @Output() delete = new EventEmitter<any>();
  @Input() isFiat = true;
  @Input() account: any = null;
  @Input() coinCode = 'ARS';

  public fiatAccountFormGroup: FormGroup;
  public cryptoAccountFormGroup: FormGroup;
  public optionModal = false;
  public successCopyIcon = false;
  public TYPE_ACCOUNT = TYPE_ACCOUNT;
  public imageCryptoCard = ICON_CARD_ACCOUNT;
  companyType = COMPANY_TYPE.BANK;
  bankIcon = '';
  constructor(private auth: AuthService) {}

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.optionModalButtonElement.nativeElement.contains(event.target)) {
      this.optionModal = false;
    }
  }

  ngOnInit(): void {
    this.resetFormGroups();
    if (this.isFiat) this.getBankIcon();
  }

  ngAfterViewInit(): void {}

  resetFormGroups() {
    this.fiatAccountFormGroup = new FormGroup({
      description: new FormControl(this.account?.description, []),
      cbu: new FormControl(this.account?.cbu, []),
    });

    this.cryptoAccountFormGroup = new FormGroup({
      description: new FormControl(this.account.description, []),
      address: new FormControl(this.account?.address, []),
    });
  }

  handlerDelete(): void {
    this.closeOptionModal();
    this.delete.emit(this.account);
  }

  openOptionModal(): void {
    this.optionModal = true;
  }

  closeOptionModal(): void {
    this.optionModal = false;
  }

  copyAccountInfo(account) {
    const text = this.isFiat ? account.cbu : account.address;
    navigator.clipboard.writeText(text);
    this.successCopyIcon = true;
    setTimeout(() => {
      this.successCopyIcon = false;
    }, 2000);
  }

  getErrorMessage(input: string) {
    const keys = Object.keys(
      (this.isFiat ? this.fiatAccountFormGroup : this.cryptoAccountFormGroup).controls[input]
        .errors,
    );
    if (keys.length === 0) {
      return '';
    }
    return errors[keys[0]];
  }

  getBankIcon() {
    //Si es citibank, mostrarlo como mercado pago
    if (this.account.bankCode === '016') {
      this.bankIcon = '/assets/icons/psp/31.svg';
      this.account.bankName = 'Mercado Pago';
      return;
    }

    //Checkear si no es PSP
    const paymentServiceCode = +this.account.cbu.slice(4, 8);

    if (this.companyType !== COMPANY_TYPE.PSP && PAYMENT_SERVICE_NAME[paymentServiceCode]) {
      this.companyType = COMPANY_TYPE.PSP;
      this.bankIcon = '/assets/icons/psp/' + paymentServiceCode + '.svg';
      this.account.bankName = PAYMENT_SERVICE_NAME[paymentServiceCode];
    } else {
      this.bankIcon = '/assets/icons/bank/' + +this.account.bankCode + '.svg';
    }
  }

  bankIconErrorHandler(imgElement: HTMLImageElement) {
    imgElement.src = '/assets/icons/bank/default.svg';
  }
}
